import React from "react";

export default function MonoSpace({ item }) {
  return <div className="mb-3" dangerouslySetInnerHTML={{ __html: item.monoSpaceHtml }} />;
}
